/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

const NoResult = () => (
  <Message
    icon="unlinkify"
    header="Aucun résultat"
    content="Aucune page ne correspond aux critères de votre recherche"
  />
);

export default NoResult;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Pages/components/NoResult.js